<template>
  <FullscreenFrontageDialog ref="frontageDialog">
    <template>
      <CallerIdSettings :show="true"
                         @goToSettings="handleSubmit"
                         @cancel="handleClose"/>
    </template>
  </FullscreenFrontageDialog>
</template>

<script>
import {FullscreenFrontageDialog} from "@/modules/common/components";
import CallerIdSettings from "@/modules/callerId/components/CallerIdSettings.vue";

export default {
  name: "CallerIdSettingsDialog",
  components: {FullscreenFrontageDialog, CallerIdSettings},
  methods: {
    handleSubmit() {
      this.$refs.frontageDialog.handleSubmit();
    },
    handleClose() {
      this.$refs.frontageDialog.handleClose();
    }
  }
}
</script>
